import { ColorMode } from '@revolut-internal/ui-kit'

import { LocalStorageKeys } from 'lib/shared/consts'

// ErrorFallback renders outside the main Providers tree (the ErrorBoundary in
// Bootstrap.tsx wraps Providers), so we cannot read theme mode from context.
// Read the user's preference directly from localStorage instead.
export const getInitialThemeMode = (): ColorMode => {
  try {
    const stored = window.localStorage.getItem(LocalStorageKeys.DARK_MODE)
    return stored && JSON.parse(stored) === true ? ColorMode.DARK : ColorMode.LIGHT
  } catch {
    return ColorMode.LIGHT
  }
}
